import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, TrendingUp, LogIn, UserPlus, PiggyBank, Receipt, Wand2, X, CheckCircle2, Globe, MessageCircle, Loader2, Lock, ExternalLink, Eye, EyeOff } from "lucide-react";

// Real client portfolio — colored, marquee left→right, password-gated.
// Password to open any of these sites is set below in PasswordGateModal.
const PORTFOLIO_ITEMS = [
  {
    name: "FlowUp — Full Frame",
    subtitle: "מערכת CRM אישית",
    url: "https://flow-up.co.il/full-frame",
    gradient: "linear-gradient(135deg, #1E3A8A 0%, #3B82F6 100%)",
    text: "#FFFFFF",
    accent: "#FDE68A",
  },
  {
    name: "Men's Health Israel",
    subtitle: "פורטל תוכן ובריאות",
    url: "https://menshealth.co.il/",
    gradient: "linear-gradient(135deg, #7C2D12 0%, #EA580C 100%)",
    text: "#FFFFFF",
    accent: "#FED7AA",
  },
  {
    name: "Men's Health · Bari",
    subtitle: "מיני-אתר קמפיין",
    url: "https://menshealth.co.il/bari",
    gradient: "linear-gradient(135deg, #14532D 0%, #22C55E 100%)",
    text: "#FFFFFF",
    accent: "#BBF7D0",
  },
  {
    name: "Daniel Hassine",
    subtitle: "מערכת ניהול פיננסי",
    url: "https://danielhassine.com/login",
    gradient: "linear-gradient(135deg, #4C1D95 0%, #A855F7 100%)",
    text: "#FFFFFF",
    accent: "#F5D0FE",
  },
];

const PORTFOLIO_PASSWORD = "12345";

export default function Landing() {
  const [showPricing, setShowPricing] = useState(false);
  const [gateItem, setGateItem] = useState(null); // portfolio item awaiting password
  return (
    <div
      className="min-h-screen p-4 py-10"
      style={{
        background:
          "radial-gradient(1400px 700px at 85% -10%, #E7F1EA 0%, transparent 55%), radial-gradient(1000px 600px at -10% 110%, #FCE7D8 0%, transparent 55%), #F9FAF9",
      }}
    >
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center min-h-[70vh]">
        <div className="text-end space-y-6">
          <div className="inline-flex items-center gap-2 chip">
            <Sparkles size={14} /> חדש · חינם · ללא התחייבות
          </div>
          <h1 className="text-5xl md:text-6xl leading-tight font-heebo font-black text-slate-900">
            ניהול פיננסי אישי
          </h1>
          <p className="text-slate-600 text-lg max-w-md ms-auto font-heebo">
            הכנסות, הוצאות, חסכונות ומיסים — הכל במקום אחד, בעברית,
            בממשק ייחודי, נוח וידידותי. חישוב אוטומטי של מע״מ, מס הכנסה,
            ביטוח לאומי ועוד…
          </p>
          <div className="flex flex-wrap gap-3 justify-end">
            <button
              type="button"
              onClick={() => setShowPricing(true)}
              className="btn-primary text-lg px-6 py-3"
              data-testid="landing-signup-btn"
            >
              <UserPlus size={20} /> הירשמו עכשיו — חינם
            </button>
            <Link
              to="/login"
              className="btn-secondary text-lg px-6 py-3"
              data-testid="landing-login-btn"
            >
              <LogIn size={20} /> אני כבר רשום — היכנס
            </Link>
          </div>
        </div>

        <div className="card-surface p-6 md:p-8 grain space-y-4">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: "var(--brand)", color: "#fff" }}>
              <TrendingUp size={22} />
            </div>
            <div>
              <div className="font-heebo font-bold text-lg">מה בפנים?</div>
              <div className="text-xs text-slate-500">כל מה שצריך לניהול נבון</div>
            </div>
          </div>

          <FeatureRow icon={<Wand2 size={18} />} iconBg="#E0F2FE" iconColor="#075985" title="Custom-made — התאמה אישית" desc={'שינויים במערכת לפי הצרכים האישיים שלך. אנחנו בונים איתך פיצ\'רים חדשים לפי דרישה.'} />
          <FeatureRow icon={<Receipt size={18} />} iconBg="#FDECEC" iconColor="#B91C1C" title="הוצאות קבועות ומשתנות" desc="קטגוריות, קבצים לכל שורה, סימון ↻ קבוע שמתפשט אוטומטית לכל חודש עתידי" />
          <FeatureRow icon={<TrendingUp size={18} />} iconBg="#DCFCE7" iconColor="#166534" title="הכנסות עם WhatsApp אוטומטי" desc="כפתור פנייה מהיר, שליחת הצעות מחיר ודרישות תשלום" />
          <FeatureRow icon={<PiggyBank size={18} />} iconBg="#EDE9FE" iconColor="#5B21B6" title="חסכונות והפרשות אוטומטיות" desc="פנסיה, קרן השתלמות — נכנסים אוטומטית כל תחילת חודש" />
          <FeatureRow icon={<Sparkles size={18} />} iconBg="#FEF3C7" iconColor="#92400E" title="חישוב מס חכם" desc={'מע"מ, מס הכנסה, ביטוח לאומי — לפי השיעורים שאתה מגדיר. תמיד כלול-במס.'} />
        </div>
      </div>

      {showPricing && <LandingPricingPopup onClose={() => setShowPricing(false)} />}

      <PortfolioMarquee onOpen={setGateItem} />

      {gateItem && (
        <PasswordGateModal
          item={gateItem}
          onClose={() => setGateItem(null)}
          onSuccess={(url) => {
            setGateItem(null);
            window.open(url, "_blank", "noopener,noreferrer");
          }}
        />
      )}
    </div>
  );
}

function PortfolioMarquee({ onOpen }) {
  // Duplicate the array so the strip loops seamlessly.
  const items = [...PORTFOLIO_ITEMS, ...PORTFOLIO_ITEMS];
  return (
    <div className="max-w-6xl mx-auto mt-12" data-testid="landing-portfolio">
      <div className="text-center mb-6">
        <div className="inline-flex items-center gap-2 chip mb-3">
          <Sparkles size={14} /> אתרים ומערכות שבנינו ללקוחות
        </div>
        <h2 className="text-2xl md:text-3xl font-heebo font-black text-slate-900">בין הפרויקטים שלנו</h2>
        <p className="text-sm text-slate-500 font-heebo mt-1">כל כרטיס פותח את האתר של הלקוח — נדרשת סיסמת כניסה</p>
      </div>

      <div className="portfolio-marquee-wrap" data-testid="portfolio-marquee">
        <div className="portfolio-marquee-track">
          {items.map((it, idx) => (
            <PortfolioCard key={`${it.url}-${idx}`} item={it} onClick={() => onOpen(it)} />
          ))}
        </div>
      </div>
    </div>
  );
}

function PortfolioCard({ item, onClick }) {
  return (
    <div
      className="portfolio-card"
      style={{ background: item.gradient, color: item.text }}
      data-testid={`portfolio-card-${item.url}`}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="text-[10px] font-heebo font-bold uppercase tracking-wider opacity-80" style={{ color: item.accent }}>
          פרויקט לקוח
        </div>
        <Lock size={14} style={{ color: item.accent }} />
      </div>
      <div className="font-heebo font-black text-xl leading-tight" dir="auto">{item.name}</div>
      <div className="text-xs font-heebo opacity-90 mt-1">{item.subtitle}</div>
      <div className="text-[11px] font-mono mt-3 opacity-70 truncate" dir="ltr">{item.url.replace(/^https?:\/\//, "")}</div>
      <button
        type="button"
        onClick={onClick}
        className="mt-4 w-full inline-flex items-center justify-center gap-1.5 rounded-xl bg-white/95 text-slate-900 font-heebo font-bold text-sm py-2.5 hover:bg-white transition"
        data-testid={`portfolio-enter-${item.url}`}
      >
        <LogIn size={14} /> כניסה / התחברות
      </button>
    </div>
  );
}

function PasswordGateModal({ item, onClose, onSuccess }) {
  const [pwd, setPwd] = useState("");
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (pwd === PORTFOLIO_PASSWORD) {
      onSuccess(item.url);
    } else {
      setErr("סיסמה שגויה. פנה לדניאל לקבלת גישה.");
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="portfolio-gate">
      <form onSubmit={submit} className="card-surface p-6 max-w-sm w-full grain relative">
        <button type="button" onClick={onClose} className="absolute top-3 left-3 p-1 rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700 transition" aria-label="סגור" data-testid="portfolio-gate-close">
          <X size={18} />
        </button>
        <div className="flex flex-col items-center text-center mb-4">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-3" style={{ background: item.gradient, color: item.accent }}>
            <Lock size={26} />
          </div>
          <div className="font-heebo font-black text-lg text-slate-900">כניסה ל-{item.name}</div>
          <div className="text-xs text-slate-500 font-heebo mt-1">אתר לקוח פרטי — נדרשת סיסמה</div>
        </div>

        <label className="block mb-3">
          <div className="text-xs text-slate-500 mb-1 font-heebo">סיסמה</div>
          <div className="relative">
            <input
              type="text"
              className={`input-field pr-12 ${show ? "" : "pw-masked"}`}
              value={pwd}
              onChange={(e) => { setPwd(e.target.value); setErr(""); }}
              required
              autoFocus
              dir="ltr"
              autoComplete="off"
              data-lpignore="true"
              data-1p-ignore="true"
              data-bwignore="true"
              data-form-type="other"
              name="pw-portfolio-gate"
              style={{ paddingRight: "3rem" }}
              data-testid="portfolio-gate-input"
            />
            <button
              type="button"
              onClick={() => setShow((v) => !v)}
              className="absolute inset-y-0 right-2 flex items-center px-2 text-slate-500 hover:text-slate-800 transition"
              tabIndex={-1}
              aria-label={show ? "הסתר" : "הצג"}
            >
              {show ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </label>

        {err && (
          <div className="mb-3 chip chip-danger" data-testid="portfolio-gate-error">{err}</div>
        )}

        <button type="submit" className="btn-primary w-full justify-center" data-testid="portfolio-gate-submit">
          <ExternalLink size={16} /> פתח אתר
        </button>
      </form>
    </div>
  );
}

function LandingPricingPopup({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" data-testid="landing-pricing-popup">
      <div className="card-surface p-6 md:p-8 max-w-md w-full grain relative">
        <button type="button" onClick={onClose} className="absolute top-4 left-4 p-1 rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700 transition" aria-label="סגור" data-testid="landing-pricing-close">
          <X size={18} />
        </button>
        <div className="flex flex-col items-center text-center mb-4">
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-3" style={{ background: "linear-gradient(135deg, #DCFCE7, #A7F3D0)", color: "#166534" }}>
            <Sparkles size={30} />
          </div>
          <div className="font-heebo font-black text-2xl text-slate-900">חודש ניסיון חינם</div>
        </div>

        <div className="rounded-xl p-4 border mb-4" style={{ background: "linear-gradient(135deg, #EFF6FF, #DBEAFE)", borderColor: "#93C5FD" }} data-testid="landing-pricing-plan">
          <div className="flex items-baseline justify-between mb-1">
            <div className="text-xs font-heebo text-blue-800">לאחר החודש הראשון</div>
            <div>
              <span className="num-pop text-3xl text-blue-900">129 ₪</span>
              <span className="text-xs text-blue-700 font-heebo mr-1">/ חודש</span>
            </div>
          </div>
          <ul className="space-y-2 mt-3 text-sm font-heebo text-blue-900">
            <li className="flex items-center gap-2"><CheckCircle2 size={14} /> אחסון 500 MB</li>
            <li className="flex items-center gap-2"><Globe size={14} /> דומיין אישי משלך</li>
            <li className="flex items-center gap-2"><MessageCircle size={14} /> שירות אישי בוואטסאפ</li>
            <li className="flex items-center gap-2"><CheckCircle2 size={14} /> ביטול בכל עת · ללא התחייבות</li>
          </ul>
        </div>

        <Link to="/register" className="btn-primary w-full justify-center text-lg py-3" data-testid="landing-pricing-continue">
          <Sparkles size={16} /> המשך להרשמה
        </Link>
        <button type="button" onClick={onClose} className="mt-2 w-full text-xs text-slate-500 hover:text-slate-800 font-heebo py-2" data-testid="landing-pricing-cancel">
          חזרה
        </button>
      </div>
    </div>
  );
}

function FeatureRow({ icon, iconBg, iconColor, title, desc }) {
  return (
    <div className="flex items-start gap-3 p-3 rounded-xl hover:bg-slate-50 transition">
      <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{ background: iconBg, color: iconColor }}>
        {icon}
      </div>
      <div>
        <div className="font-heebo font-semibold text-slate-800">{title}</div>
        <div className="text-xs text-slate-500 font-heebo mt-0.5">{desc}</div>
      </div>
    </div>
  );
}

function FeatureRow_inline({ icon, iconBg, iconColor, title, desc }) {
  return (
    <div className="flex items-start gap-3 p-3 rounded-xl hover:bg-slate-50 transition">
      <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{ background: iconBg, color: iconColor }}>
        {icon}
      </div>
      <div>
        <div className="font-heebo font-semibold text-slate-800">{title}</div>
        <div className="text-xs text-slate-500 font-heebo mt-0.5">{desc}</div>
      </div>
    </div>
  );
}
